import { NetVarianceRow, VarianceUpdate } from './types';

export async function fetchVariance(startDate: string, endDate: string): Promise<NetVarianceRow[]> {
  const params = new URLSearchParams({ startDate, endDate });
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/smrt-timetrack/variance?${params}`,
    { credentials: 'include' },
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `Request failed (HTTP ${res.status})`);
  }
  const data = await res.json() as { rows?: NetVarianceRow[] };
  return data.rows ?? [];
}

export async function saveVarianceUpdates(updates: VarianceUpdate[]): Promise<void> {
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/smrt-timetrack/variance/bulk`,
    {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    },
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `Save failed (HTTP ${res.status})`);
  }
}
